/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** A field whose value is a JSON Web Token (JWT): https://jwt.io/introduction. */
  JWT: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export enum AcceptedCountries {
  Hk = 'HK',
  Jp = 'JP'
}

export type Address = {
  __typename?: 'Address';
  addressLine?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  googlePlaceId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  addressLine?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  googlePlaceId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type Admin = {
  __typename?: 'Admin';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  isActivated: Scalars['Boolean'];
  name: Scalars['String'];
  role: AdminRole;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime'];
};

export type AdminAuth = {
  __typename?: 'AdminAuth';
  /** JWT access token */
  accessToken: Scalars['JWT'];
  admin: Admin;
  /** OTP code, only return in development/UAT mode */
  otp?: Maybe<Scalars['String']>;
  /** JWT refresh token */
  refreshToken: Scalars['JWT'];
};

export type AdminBlog = {
  __typename?: 'AdminBlog';
  author: Scalars['String'];
  blogContent?: Maybe<BlogContent>;
  blogContents: Array<BlogContent>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime'];
  featureImage: Scalars['String'];
  id: Scalars['ID'];
  publishedAt: Scalars['DateTime'];
  slug: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime'];
};

export type AdminBlogConnection = {
  __typename?: 'AdminBlogConnection';
  items?: Maybe<Array<AdminBlog>>;
  total: Scalars['Int'];
};

export type AdminCreateShopInput = {
  authentications?: InputMaybe<Array<Scalars['String']>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  /** The country of the shop */
  country: AcceptedCountries;
  deliveryOptions?: InputMaybe<Array<ShopDeliveryOptionInput>>;
  description: TranslationColumnInput;
  isActivated?: InputMaybe<Scalars['Boolean']>;
  isOnline?: InputMaybe<Scalars['Boolean']>;
  name: TranslationColumnInput;
  socialMedias?: InputMaybe<Array<ShopSocialMediaInput>>;
  stores?: InputMaybe<Array<CreateStoreInput>>;
  userId?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type AdminLoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

/** Admin role */
export enum AdminRole {
  Admin = 'ADMIN',
  SuperAdmin = 'SUPER_ADMIN'
}

export type AdminUpdateShopInput = {
  authentications?: InputMaybe<Array<Scalars['String']>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  /** The country of the shop */
  country: AcceptedCountries;
  deliveryOptions?: InputMaybe<Array<ShopDeliveryOptionInput>>;
  description?: InputMaybe<TranslationColumnInput>;
  isActivated?: InputMaybe<Scalars['Boolean']>;
  isOnline?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<TranslationColumnInput>;
  socialMedias?: InputMaybe<Array<UpdateShopSocialMediaInput>>;
  stores?: InputMaybe<Array<UpdateStoreInput>>;
  userId?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type Auth = {
  __typename?: 'Auth';
  /** JWT access token */
  accessToken: Scalars['JWT'];
  /** OTP code, only return in development/UAT mode */
  otp?: Maybe<Scalars['String']>;
  /** JWT refresh token */
  refreshToken: Scalars['JWT'];
  user: User;
};

export type AuthenticationType = {
  __typename?: 'AuthenticationType';
  /** The unique code of the authentication type */
  code: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime'];
  /** The icon of the authentication type */
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** The name of the authentication type */
  name: TranslationColumn;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime'];
};

export type AuthenticationTypeConnection = {
  __typename?: 'AuthenticationTypeConnection';
  items?: Maybe<Array<AuthenticationType>>;
  total: Scalars['Int'];
};

export type Banner = {
  __typename?: 'Banner';
  buttonLabel?: Maybe<TranslationColumn>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  image: TranslationColumn;
  link?: Maybe<Scalars['String']>;
  name: TranslationColumn;
  showButton: Scalars['Boolean'];
  sortIndex?: Maybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime'];
};

export type BannerConnection = {
  __typename?: 'BannerConnection';
  items?: Maybe<Array<Banner>>;
  total: Scalars['Int'];
};

export type Blog = {
  __typename?: 'Blog';
  author: Scalars['String'];
  blogContent?: Maybe<BlogContent>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime'];
  featureImage: Scalars['String'];
  id: Scalars['ID'];
  publishedAt: Scalars['DateTime'];
  slug: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime'];
};

export type BlogConnection = {
  __typename?: 'BlogConnection';
  items?: Maybe<Array<Blog>>;
  total: Scalars['Int'];
};

export type BlogContent = {
  __typename?: 'BlogContent';
  blogContentSections?: Maybe<Array<BlogContentSection>>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  language: Scalars['String'];
  rawContent: Scalars['String'];
  title: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime'];
};

export type BlogContentInput = {
  blogContentSections: Array<BlogSectionInput>;
  description?: InputMaybe<Scalars['String']>;
  language: Scalars['String'];
  title: Scalars['String'];
};

export type BlogContentSection = {
  __typename?: 'BlogContentSection';
  content: Scalars['JSONObject'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  sortIndex: Scalars['Int'];
  type: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime'];
};

export type BlogSectionInput = {
  content: Scalars['JSONObject'];
  type: BlogSectionType;
};

export enum BlogSectionType {
  Article = 'ARTICLE',
  Image = 'IMAGE',
  Quote = 'QUOTE'
}

export type Category = {
  __typename?: 'Category';
  children?: Maybe<Array<Category>>;
  /** The category slug code */
  code: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime'];
  /** The category icon */
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** The category name in different languages */
  name: TranslationColumn;
  /** The category parent */
  parent?: Maybe<Category>;
  /** The category sort index */
  sortIndex?: Maybe<Scalars['Int']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime'];
};

export type CategoryConnection = {
  __typename?: 'CategoryConnection';
  items?: Maybe<Array<Category>>;
  total: Scalars['Int'];
};

export type CategorySortingInput = {
  field?: Scalars['String'];
  order?: Scalars['String'];
};

export type Config = {
  __typename?: 'Config';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime'];
  value: TranslationColumn;
};

export type ConfigConnection = {
  __typename?: 'ConfigConnection';
  items?: Maybe<Array<Config>>;
  total: Scalars['Int'];
};

export type CreateAdminInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  role?: InputMaybe<AdminRole>;
};

export type CreateAuthenticationTypeInput = {
  /** The unique of the object */
  code: Scalars['String'];
  /** The object name in different languages */
  name: TranslationColumnInput;
};

export type CreateBannerInput = {
  buttonLabel?: InputMaybe<TranslationColumnInput>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  images: Array<LanguageImageInput>;
  link?: InputMaybe<Scalars['String']>;
  name: TranslationColumnInput;
  showButton?: InputMaybe<Scalars['Boolean']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  startDate: Scalars['DateTime'];
};

export type CreateBlogInput = {
  author: Scalars['String'];
  blogContents: Array<BlogContentInput>;
  featureImage: Scalars['Upload'];
  publishedAt: Scalars['DateTime'];
  slug: Scalars['String'];
};

export type CreateCategoryInput = {
  /** The unique of the object */
  code: Scalars['String'];
  /** The category is active */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** The object icon */
  icon?: InputMaybe<Scalars['String']>;
  /** The object name in different languages */
  name: TranslationColumnInput;
  /** The category parent id */
  parentId?: InputMaybe<Scalars['String']>;
  /** The object sort index */
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type CreateConfigInput = {
  description?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  name: Scalars['String'];
  value: TranslationColumnInput;
};

export type CreateDeliveryOptionInput = {
  additionalInfoLabel?: InputMaybe<TranslationColumnInput>;
  /** The unique of the object */
  code: Scalars['String'];
  /** The object icon */
  icon?: InputMaybe<Scalars['String']>;
  /** The object name in different languages */
  name: TranslationColumnInput;
  /** Can show the additional information text input */
  showAdditionalInfo?: InputMaybe<Scalars['Boolean']>;
  /** The object sort index */
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type CreateDeliveryServiceProviderInput = {
  additionalInfoLabel?: InputMaybe<TranslationColumnInput>;
  /** The unique of the object */
  code: Scalars['String'];
  /** The object icon */
  icon?: InputMaybe<Scalars['String']>;
  /** The object name in different languages */
  name: TranslationColumnInput;
  /** Can show the additional information text input */
  showAdditionalInfo?: InputMaybe<Scalars['Boolean']>;
  /** The object sort index */
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type CreateSearchSuggestionInput = {
  code: Scalars['String'];
  country: AcceptedCountries;
  enabled?: InputMaybe<Scalars['Boolean']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  name: TranslationColumnInput;
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type CreateShopImageInput = {
  image: Scalars['Upload'];
  type?: ShopImageType;
};

export type CreateShopInput = {
  authentications?: InputMaybe<Array<Scalars['String']>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  /** The country of the shop */
  country: AcceptedCountries;
  deliveryOptions?: InputMaybe<Array<ShopDeliveryOptionInput>>;
  description: TranslationColumnInput;
  isOnline?: InputMaybe<Scalars['Boolean']>;
  name: TranslationColumnInput;
  socialMedias?: InputMaybe<Array<ShopSocialMediaInput>>;
  stores?: InputMaybe<Array<CreateStoreInput>>;
  website?: InputMaybe<Scalars['String']>;
};

export type CreateSocialMediaInput = {
  /** The unique of the object */
  code: Scalars['String'];
  hintText?: InputMaybe<TranslationColumnInput>;
  /** The object icon */
  icon?: InputMaybe<Scalars['String']>;
  /** The object name in different languages */
  name: TranslationColumnInput;
};

export type CreateStoreInput = {
  address: AddressInput;
  /** Closing time of the store, format: hh:mm */
  closingTime?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<TranslationColumnInput>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  name?: InputMaybe<TranslationColumnInput>;
  /** Opening time of the store, format: hh:mm */
  openingTime?: InputMaybe<Scalars['String']>;
  workingDays?: InputMaybe<WorkingDaysInput>;
};

export type CreateUserInput = {
  countryCode: Scalars['String'];
  phone: Scalars['String'];
  status: UserStatus;
};

export type DeleteShopImagesInput = {
  ids: Array<Scalars['String']>;
};

export type DeliveryOption = {
  __typename?: 'DeliveryOption';
  additionalInfoLabel?: Maybe<TranslationColumn>;
  /** The unique of the object */
  code: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime'];
  /** The object icon */
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** The object is active or not */
  isActive: Scalars['Boolean'];
  /** The object name in different languages */
  name: TranslationColumn;
  serviceProviders?: Maybe<Array<DeliveryServiceProvider>>;
  /** Can show the additional information text input */
  showAdditionalInfo: Scalars['Boolean'];
  /** The object sort index */
  sortIndex?: Maybe<Scalars['Int']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime'];
};

export type DeliveryOptionConnection = {
  __typename?: 'DeliveryOptionConnection';
  items?: Maybe<Array<DeliveryOption>>;
  total: Scalars['Int'];
};

export type DeliveryServiceProvider = {
  __typename?: 'DeliveryServiceProvider';
  additionalInfoLabel?: Maybe<TranslationColumn>;
  /** The unique of the object */
  code: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime'];
  /** The delivery option */
  deliveryOption: DeliveryOption;
  id: Scalars['ID'];
  /** The object is active or not */
  isActive: Scalars['Boolean'];
  /** The object name in different languages */
  name: TranslationColumn;
  /** Can show the additional information text input */
  showAdditionalInfo: Scalars['Boolean'];
  /** The object sort index */
  sortIndex?: Maybe<Scalars['Int']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime'];
};

export type DeliveryServiceProviderConnection = {
  __typename?: 'DeliveryServiceProviderConnection';
  items?: Maybe<Array<DeliveryServiceProvider>>;
  total: Scalars['Int'];
};

export type LanguageImageInput = {
  file: Scalars['Upload'];
  language: Scalars['String'];
};

export type LocationArgs = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  /** Radius in mile, default is 5 */
  radius?: InputMaybe<Scalars['Float']>;
};

export type LoginInput = {
  countryCode: Scalars['String'];
  otp?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  adminAuthenticationTypeCreate: AuthenticationType;
  adminAuthenticationTypeRemove: AuthenticationType;
  adminAuthenticationTypeUpdate: AuthenticationType;
  adminBannerCreate: Banner;
  adminBannerRemove: Banner;
  adminBannerUpdate: Banner;
  adminBlogCreate: AdminBlog;
  adminBlogRemove: AdminBlog;
  adminBlogUpdate: AdminBlog;
  adminCategoryCreate: Category;
  adminCategoryUpdate: Category;
  adminConfigCreate: Config;
  adminConfigRemove: Config;
  adminConfigUpdate: Config;
  adminDeleteShopImages: Array<ShopImage>;
  adminDeliveryOptionCreate: DeliveryOption;
  adminDeliveryOptionRemove: DeliveryOption;
  adminDeliveryOptionUpdate: DeliveryOption;
  adminDeliveryServiceProviderCreate: DeliveryServiceProvider;
  adminLogin: AdminAuth;
  adminRefreshToken: Token;
  /** Register a new admin */
  adminRegister: AdminAuth;
  adminRemoveDeliveryServiceProvider: DeliveryServiceProvider;
  adminSearchSuggestionCreate: SearchSuggestion;
  adminSearchSuggestionRemove: SearchSuggestion;
  adminSearchSuggestionUpdate: SearchSuggestion;
  adminSetIsFeature: Scalars['Boolean'];
  /** Create a new shop By Admin */
  adminShopCreate: Shop;
  /** Update a shop By Admin */
  adminShopUpdate: Shop;
  adminSocialMediaCreate: SocialMedia;
  adminSocialMediaRemove: SocialMedia;
  adminSocialMediaUpdate: SocialMedia;
  adminUpdateDeliveryServiceProvider: DeliveryServiceProvider;
  adminUploadShopImages: Array<ShopImage>;
  /** Create a new user by admin */
  adminUserCreate: User;
  /** Update user by admin */
  adminUserUpdate: User;
  deleteShopImages: Array<ShopImage>;
  login: Auth;
  refreshToken: Token;
  register: Auth;
  requestOtp: RequestOtpResponse;
  setIsFeature: Scalars['Boolean'];
  /** Create a new shop By User */
  shopCreate: Shop;
  /** Update a new shop By User */
  shopUpdate: Shop;
  /** Create a new store By User */
  storeCreate: Store;
  /** Delete a store By User */
  storeDelete: Store;
  /** Update a new store By User */
  storeUpdate: Store;
  uploadShopImages: Array<ShopImage>;
  verifyOtp: Scalars['Boolean'];
};


export type MutationAdminAuthenticationTypeCreateArgs = {
  createAuthenticationTypeInput: CreateAuthenticationTypeInput;
};


export type MutationAdminAuthenticationTypeRemoveArgs = {
  id: Scalars['String'];
};


export type MutationAdminAuthenticationTypeUpdateArgs = {
  id: Scalars['String'];
  updateAuthenticationTypeInput: UpdateAuthenticationTypeInput;
};


export type MutationAdminBannerCreateArgs = {
  createBannerInput: CreateBannerInput;
};


export type MutationAdminBannerRemoveArgs = {
  id: Scalars['String'];
};


export type MutationAdminBannerUpdateArgs = {
  id: Scalars['String'];
  updateBannerInput: UpdateBannerInput;
};


export type MutationAdminBlogCreateArgs = {
  createBlogInput: CreateBlogInput;
};


export type MutationAdminBlogRemoveArgs = {
  id: Scalars['String'];
};


export type MutationAdminBlogUpdateArgs = {
  id: Scalars['String'];
  updateBlogInput: UpdateBlogInput;
};


export type MutationAdminCategoryCreateArgs = {
  createCategoryInput: CreateCategoryInput;
};


export type MutationAdminCategoryUpdateArgs = {
  id: Scalars['String'];
  updateCategoryInput: UpdateCategoryInput;
};


export type MutationAdminConfigCreateArgs = {
  data: CreateConfigInput;
};


export type MutationAdminConfigRemoveArgs = {
  id: Scalars['String'];
};


export type MutationAdminConfigUpdateArgs = {
  data: UpdateConfigInput;
  id: Scalars['String'];
};


export type MutationAdminDeleteShopImagesArgs = {
  data: DeleteShopImagesInput;
  id: Scalars['String'];
};


export type MutationAdminDeliveryOptionCreateArgs = {
  createDeliveryOptionInput: CreateDeliveryOptionInput;
};


export type MutationAdminDeliveryOptionRemoveArgs = {
  id: Scalars['String'];
};


export type MutationAdminDeliveryOptionUpdateArgs = {
  id: Scalars['String'];
  updateDeliveryOptionInput: UpdateDeliveryOptionInput;
};


export type MutationAdminDeliveryServiceProviderCreateArgs = {
  createDeliveryServiceProviderInput: CreateDeliveryServiceProviderInput;
  optionId: Scalars['String'];
};


export type MutationAdminLoginArgs = {
  data: AdminLoginInput;
};


export type MutationAdminRefreshTokenArgs = {
  token: Scalars['JWT'];
};


export type MutationAdminRegisterArgs = {
  data: CreateAdminInput;
};


export type MutationAdminRemoveDeliveryServiceProviderArgs = {
  id: Scalars['String'];
};


export type MutationAdminSearchSuggestionCreateArgs = {
  data: CreateSearchSuggestionInput;
};


export type MutationAdminSearchSuggestionRemoveArgs = {
  id: Scalars['String'];
};


export type MutationAdminSearchSuggestionUpdateArgs = {
  data: UpdateSearchSuggestionInput;
  id: Scalars['String'];
};


export type MutationAdminSetIsFeatureArgs = {
  id: Scalars['String'];
};


export type MutationAdminShopCreateArgs = {
  data: AdminCreateShopInput;
};


export type MutationAdminShopUpdateArgs = {
  data: AdminUpdateShopInput;
  shopId: Scalars['String'];
};


export type MutationAdminSocialMediaCreateArgs = {
  createSocialMediaInput: CreateSocialMediaInput;
};


export type MutationAdminSocialMediaRemoveArgs = {
  id: Scalars['String'];
};


export type MutationAdminSocialMediaUpdateArgs = {
  id: Scalars['String'];
  updateSocialMediaInput: UpdateSocialMediaInput;
};


export type MutationAdminUpdateDeliveryServiceProviderArgs = {
  id: Scalars['String'];
  updateDeliveryServiceProviderInput: UpdateDeliveryServiceProviderInput;
};


export type MutationAdminUploadShopImagesArgs = {
  data: Array<CreateShopImageInput>;
  id: Scalars['String'];
};


export type MutationAdminUserCreateArgs = {
  data: CreateUserInput;
};


export type MutationAdminUserUpdateArgs = {
  data: UpdateUserInput;
  id: Scalars['String'];
};


export type MutationDeleteShopImagesArgs = {
  data: DeleteShopImagesInput;
};


export type MutationLoginArgs = {
  data: LoginInput;
};


export type MutationRefreshTokenArgs = {
  token: Scalars['JWT'];
};


export type MutationRegisterArgs = {
  data: RegisterInput;
};


export type MutationRequestOtpArgs = {
  data: RequestOtpInput;
};


export type MutationSetIsFeatureArgs = {
  id: Scalars['String'];
};


export type MutationShopCreateArgs = {
  data: CreateShopInput;
};


export type MutationShopUpdateArgs = {
  data: UpdateShopInput;
  shopId: Scalars['String'];
};


export type MutationStoreCreateArgs = {
  data: CreateStoreInput;
  shopId: Scalars['String'];
};


export type MutationStoreDeleteArgs = {
  storeId: Scalars['String'];
};


export type MutationStoreUpdateArgs = {
  data: UpdateStoreInput;
  storeId: Scalars['String'];
};


export type MutationUploadShopImagesArgs = {
  data: Array<CreateShopImageInput>;
  id: Scalars['String'];
};


export type MutationVerifyOtpArgs = {
  data: VerifyOtpInput;
};

export enum OtpType {
  ForgotPassword = 'FORGOT_PASSWORD',
  Login = 'LOGIN',
  Register = 'REGISTER'
}

export type Query = {
  __typename?: 'Query';
  adminAuthenticationType: AuthenticationType;
  adminAuthenticationTypes: AuthenticationTypeConnection;
  /** Get a Banner by id */
  adminBanner: Banner;
  /** Get banners */
  adminBanners: BannerConnection;
  /** Get a Blog by id */
  adminBlog: AdminBlog;
  /** Get blogs */
  adminBlogs: AdminBlogConnection;
  adminCategories: CategoryConnection;
  adminCategory: Category;
  adminConfig: Config;
  adminConfigs: ConfigConnection;
  adminDeliveryOption: DeliveryOption;
  adminDeliveryOptions: DeliveryOptionConnection;
  adminDeliveryServiceProvider: DeliveryServiceProvider;
  adminDeliveryServiceProviders: DeliveryServiceProviderConnection;
  adminMe: Admin;
  adminSearchSuggestion: SearchSuggestion;
  adminSearchSuggestions: SearchSuggestionConnection;
  /** Get a shop by Admin */
  adminShop: Shop;
  /** Get all shops By Admin */
  adminShops: ShopConnection;
  adminSocialMedia: SocialMedia;
  adminSocialMedias: SocialMediaConnection;
  /** Get user by id */
  adminUser: User;
  /** Get all users by admin */
  adminUsers: UserConnection;
  authenticationTypes: AuthenticationTypeConnection;
  /** Get a Banner by id */
  banner: Banner;
  /** Get banners */
  banners: BannerConnection;
  /** Get a Blog by id or slug */
  blog: Blog;
  /** Get blogs */
  blogs: BlogConnection;
  categories: CategoryConnection;
  category: Category;
  configs: ConfigConnection;
  deliveryOption: DeliveryServiceProvider;
  deliveryOptions: DeliveryOptionConnection;
  deliveryServiceProviders: DeliveryServiceProviderConnection;
  hello: Scalars['String'];
  helloWorld: Scalars['String'];
  me: User;
  /** Get a shop by user */
  myShop?: Maybe<Shop>;
  searchSuggestion: SearchSuggestionConnection;
  /** Get a shop by id */
  shop: Shop;
  /** Get shops */
  shops: ShopConnection;
  socialMedia: SocialMedia;
  socialMedias: SocialMediaConnection;
};


export type QueryAdminAuthenticationTypeArgs = {
  id: Scalars['String'];
};


export type QueryAdminAuthenticationTypesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryAdminBannerArgs = {
  id: Scalars['String'];
};


export type QueryAdminBannersArgs = {
  isExpired?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryAdminBlogArgs = {
  id: Scalars['String'];
};


export type QueryAdminBlogsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryAdminCategoriesArgs = {
  parentOnly?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryAdminCategoryArgs = {
  id: Scalars['String'];
};


export type QueryAdminConfigArgs = {
  id: Scalars['String'];
};


export type QueryAdminDeliveryOptionArgs = {
  id: Scalars['String'];
};


export type QueryAdminDeliveryOptionsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryAdminDeliveryServiceProviderArgs = {
  id: Scalars['String'];
};


export type QueryAdminDeliveryServiceProvidersArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryAdminSearchSuggestionArgs = {
  id: Scalars['String'];
};


export type QueryAdminShopArgs = {
  id: Scalars['String'];
};


export type QueryAdminShopsArgs = {
  filter?: InputMaybe<ShopFilterArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  sorting?: InputMaybe<ShopSortingInput>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryAdminSocialMediaArgs = {
  id: Scalars['String'];
};


export type QueryAdminSocialMediasArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryAdminUserArgs = {
  id: Scalars['String'];
};


export type QueryAdminUsersArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryAuthenticationTypesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBannerArgs = {
  id: Scalars['String'];
};


export type QueryBannersArgs = {
  isExpired?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryBlogArgs = {
  idOrSlug: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
};


export type QueryBlogsArgs = {
  language?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCategoriesArgs = {
  parentOnly?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  sorting?: InputMaybe<CategorySortingInput>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCategoryArgs = {
  idOrCode: Scalars['String'];
};


export type QueryDeliveryOptionArgs = {
  id: Scalars['String'];
};


export type QueryDeliveryOptionsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryDeliveryServiceProvidersArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryHelloArgs = {
  name: Scalars['String'];
};


export type QueryShopArgs = {
  id?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryShopsArgs = {
  filter?: InputMaybe<ShopFilterArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  sorting?: InputMaybe<ShopSortingInput>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QuerySocialMediaArgs = {
  id: Scalars['String'];
};


export type QuerySocialMediasArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type RegisterInput = {
  countryCode: Scalars['String'];
  otp?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
};

export type RequestOtpInput = {
  countryCode: Scalars['String'];
  phone: Scalars['String'];
  type: OtpType;
};

export type RequestOtpResponse = {
  __typename?: 'RequestOtpResponse';
  /** OTP code, only return in development/UAT mode */
  otp?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type SearchSuggestion = {
  __typename?: 'SearchSuggestion';
  code: Scalars['String'];
  country: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime'];
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  name: TranslationColumn;
  sortIndex?: Maybe<Scalars['Int']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime'];
};

export type SearchSuggestionConnection = {
  __typename?: 'SearchSuggestionConnection';
  items?: Maybe<Array<SearchSuggestion>>;
  total: Scalars['Int'];
};

export type Shop = {
  __typename?: 'Shop';
  authentications?: Maybe<Array<AuthenticationType>>;
  categories?: Maybe<Array<Category>>;
  country: AcceptedCountries;
  createdAt: Scalars['DateTime'];
  deliveryOptions?: Maybe<Array<ShopDeliveryOption>>;
  description?: Maybe<TranslationColumn>;
  id: Scalars['ID'];
  images?: Maybe<Array<ShopImage>>;
  isOnline: Scalars['Boolean'];
  /** Shop name */
  name: TranslationColumn;
  slug: Scalars['String'];
  socialMedias?: Maybe<Array<ShopSocialMedia>>;
  stores?: Maybe<Array<Store>>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  website?: Maybe<Scalars['String']>;
};

export type ShopConnection = {
  __typename?: 'ShopConnection';
  items?: Maybe<Array<Shop>>;
  total: Scalars['Int'];
};

export type ShopDeliveryOption = {
  __typename?: 'ShopDeliveryOption';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime'];
  customInfo?: Maybe<Scalars['String']>;
  deliveryOption?: Maybe<DeliveryOption>;
  deliveryServiceProvider?: Maybe<DeliveryServiceProvider>;
  id: Scalars['ID'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime'];
};

export type ShopDeliveryOptionInput = {
  customInfo?: InputMaybe<Scalars['String']>;
  /** The id of the delivery option */
  deliveryOptionId?: InputMaybe<Scalars['String']>;
  /** The id of the delivery service provider */
  deliveryServiceProviderId?: InputMaybe<Scalars['String']>;
};

export type ShopFilterArgs = {
  /** Filter by category (Code) */
  category?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<AcceptedCountries>;
  keyword?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationArgs>;
  onlineOnly?: InputMaybe<Scalars['Boolean']>;
  /** Filter by sub-categories (Code) */
  subCategories?: InputMaybe<Array<Scalars['String']>>;
};

export type ShopImage = {
  __typename?: 'ShopImage';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  originalName?: Maybe<Scalars['String']>;
  type: ShopImageType;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};

/** Type of image */
export enum ShopImageType {
  Feature = 'FEATURE',
  Gallery = 'GALLERY',
  Logo = 'LOGO'
}

export type ShopSocialMedia = {
  __typename?: 'ShopSocialMedia';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  link: Scalars['String'];
  socialMedia: SocialMedia;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime'];
};

export type ShopSocialMediaInput = {
  link?: InputMaybe<Scalars['String']>;
  /** The id of the social media */
  socialMediaId: Scalars['String'];
};

export type ShopSortingInput = {
  field?: Scalars['String'];
  order?: Scalars['String'];
};

export type SocialMedia = {
  __typename?: 'SocialMedia';
  /** The unique of the object */
  code: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime'];
  hintText?: Maybe<TranslationColumn>;
  /** The object icon */
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** The object is active or not */
  isActive: Scalars['Boolean'];
  label?: Maybe<TranslationColumn>;
  /** The object name in different languages */
  name: TranslationColumn;
  prefix?: Maybe<Scalars['String']>;
  subfix?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime'];
};

export type SocialMediaConnection = {
  __typename?: 'SocialMediaConnection';
  items?: Maybe<Array<SocialMedia>>;
  total: Scalars['Int'];
};

export type Store = {
  __typename?: 'Store';
  address?: Maybe<Address>;
  closingTime?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime'];
  description?: Maybe<TranslationColumn>;
  id: Scalars['ID'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  name?: Maybe<TranslationColumn>;
  openingTime?: Maybe<Scalars['String']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime'];
  workingDays?: Maybe<WorkingDays>;
};

export type Token = {
  __typename?: 'Token';
  /** JWT access token */
  accessToken: Scalars['JWT'];
  /** OTP code, only return in development/UAT mode */
  otp?: Maybe<Scalars['String']>;
  /** JWT refresh token */
  refreshToken: Scalars['JWT'];
};

export type TranslationColumn = {
  __typename?: 'TranslationColumn';
  /** English translation */
  en: Scalars['String'];
  /** Chinese translation */
  zhHant?: Maybe<Scalars['String']>;
};

export type TranslationColumnInput = {
  /** English translation */
  en: Scalars['String'];
  /** Chinese translation */
  zhHant?: InputMaybe<Scalars['String']>;
};

export type UpdateAuthenticationTypeInput = {
  /** The name of the authentication type */
  name: TranslationColumnInput;
};

export type UpdateBannerInput = {
  buttonLabel?: InputMaybe<TranslationColumnInput>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  images?: InputMaybe<Array<LanguageImageInput>>;
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<TranslationColumnInput>;
  showButton?: InputMaybe<Scalars['Boolean']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateBlogInput = {
  author: Scalars['String'];
  blogContents: Array<BlogContentInput>;
  featureImage?: InputMaybe<Scalars['Upload']>;
  publishedAt: Scalars['DateTime'];
};

export type UpdateCategoryInput = {
  /** The unique of the object */
  code?: InputMaybe<Scalars['String']>;
  /** The category is active */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** The object icon */
  icon?: InputMaybe<Scalars['String']>;
  /** The object name in different languages */
  name?: InputMaybe<TranslationColumnInput>;
  /** The category parent id */
  parentId?: InputMaybe<Scalars['String']>;
  /** The object sort index */
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type UpdateConfigInput = {
  value: TranslationColumnInput;
};

export type UpdateDeliveryOptionInput = {
  additionalInfoLabel?: InputMaybe<TranslationColumnInput>;
  /** The object icon */
  icon?: InputMaybe<Scalars['String']>;
  /** The object name in different languages */
  name?: InputMaybe<TranslationColumnInput>;
  /** Can show the additional information text input */
  showAdditionalInfo?: InputMaybe<Scalars['Boolean']>;
  /** The object sort index */
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type UpdateDeliveryServiceProviderInput = {
  additionalInfoLabel?: InputMaybe<TranslationColumnInput>;
  /** The object icon */
  icon?: InputMaybe<Scalars['String']>;
  /** The object name in different languages */
  name?: InputMaybe<TranslationColumnInput>;
  /** Can show the additional information text input */
  showAdditionalInfo?: InputMaybe<Scalars['Boolean']>;
  /** The object sort index */
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type UpdateSearchSuggestionInput = {
  country?: InputMaybe<AcceptedCountries>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<TranslationColumnInput>;
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type UpdateShopInput = {
  authentications?: InputMaybe<Array<Scalars['String']>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  /** The country of the shop */
  country: AcceptedCountries;
  deliveryOptions?: InputMaybe<Array<ShopDeliveryOptionInput>>;
  description?: InputMaybe<TranslationColumnInput>;
  isOnline?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<TranslationColumnInput>;
  socialMedias?: InputMaybe<Array<UpdateShopSocialMediaInput>>;
  stores?: InputMaybe<Array<UpdateStoreInput>>;
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateShopSocialMediaInput = {
  /** The id of the shop ocial media */
  id?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  /** The id of the social media */
  socialMediaId: Scalars['String'];
};

export type UpdateSocialMediaInput = {
  hintText?: InputMaybe<TranslationColumnInput>;
  /** The object icon */
  icon?: InputMaybe<Scalars['String']>;
  /** The object name in different languages */
  name?: InputMaybe<TranslationColumnInput>;
};

export type UpdateStoreInput = {
  address?: InputMaybe<AddressInput>;
  /** Closing time of the store, format: hh:mm */
  closingTime?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<TranslationColumnInput>;
  id?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<TranslationColumnInput>;
  /** Opening time of the store, format: hh:mm */
  openingTime?: InputMaybe<Scalars['String']>;
  workingDays?: InputMaybe<WorkingDaysInput>;
};

export type UpdateUserInput = {
  countryCode?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatus>;
};

export type User = {
  __typename?: 'User';
  countryCode: Scalars['String'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  phone: Scalars['String'];
  role: UserRole;
  status: UserStatus;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime'];
};

export type UserConnection = {
  __typename?: 'UserConnection';
  items?: Maybe<Array<User>>;
  total: Scalars['Int'];
};

/** User role */
export enum UserRole {
  Consumer = 'CONSUMER',
  Merchant = 'MERCHANT'
}

/** User status */
export enum UserStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Unverified = 'UNVERIFIED'
}

export type VerifyOtpInput = {
  otp: Scalars['String'];
  type: OtpType;
};

export type WorkingDays = {
  __typename?: 'WorkingDays';
  friday?: Maybe<Scalars['Boolean']>;
  monday?: Maybe<Scalars['Boolean']>;
  saturday?: Maybe<Scalars['Boolean']>;
  sunday?: Maybe<Scalars['Boolean']>;
  thursday?: Maybe<Scalars['Boolean']>;
  tuesday?: Maybe<Scalars['Boolean']>;
  wednesday?: Maybe<Scalars['Boolean']>;
};

export type WorkingDaysInput = {
  friday?: InputMaybe<Scalars['Boolean']>;
  monday?: InputMaybe<Scalars['Boolean']>;
  saturday?: InputMaybe<Scalars['Boolean']>;
  sunday?: InputMaybe<Scalars['Boolean']>;
  thursday?: InputMaybe<Scalars['Boolean']>;
  tuesday?: InputMaybe<Scalars['Boolean']>;
  wednesday?: InputMaybe<Scalars['Boolean']>;
};

export type AdminLoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type AdminLoginMutation = { __typename?: 'Mutation', adminLogin: { __typename?: 'AdminAuth', accessToken: any, refreshToken: any, admin: { __typename?: 'Admin', createdAt: any, email: string, id: string, isActivated: boolean, name: string, role: AdminRole, updatedAt: any } } };

export type AdminRefreshTokenMutationVariables = Exact<{
  token: Scalars['JWT'];
}>;


export type AdminRefreshTokenMutation = { __typename?: 'Mutation', adminRefreshToken: { __typename?: 'Token', accessToken: any, refreshToken: any } };

export type AdminMeQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminMeQuery = { __typename?: 'Query', adminMe: { __typename?: 'Admin', createdAt: any, email: string, id: string, isActivated: boolean, name: string, role: AdminRole, updatedAt: any } };

export type GetAuthenticationTypesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetAuthenticationTypesQuery = { __typename?: 'Query', adminAuthenticationTypes: { __typename?: 'AuthenticationTypeConnection', total: number, items?: Array<{ __typename?: 'AuthenticationType', code: string, createdAt: any, id: string, updatedAt: any, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } }> | null } };

export type GetAuthenticationTypeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAuthenticationTypeQuery = { __typename?: 'Query', adminAuthenticationType: { __typename?: 'AuthenticationType', code: string, createdAt: any, id: string, updatedAt: any, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } } };

export type GetBannersQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetBannersQuery = { __typename?: 'Query', adminBanners: { __typename?: 'BannerConnection', total: number, items?: Array<{ __typename?: 'Banner', id: string, link?: string | null, sortIndex?: number | null, showButton: boolean, startDate: any, endDate?: any | null, createdAt: any, updatedAt: any, buttonLabel?: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } | null, image: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null }, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } }> | null } };

export type GetBannerQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBannerQuery = { __typename?: 'Query', adminBanner: { __typename?: 'Banner', id: string, link?: string | null, showButton: boolean, sortIndex?: number | null, startDate: any, endDate?: any | null, createdAt: any, updatedAt: any, buttonLabel?: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } | null, image: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null }, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } } };

export type CreateBannerMutationVariables = Exact<{
  input: CreateBannerInput;
}>;


export type CreateBannerMutation = { __typename?: 'Mutation', adminBannerCreate: { __typename?: 'Banner', id: string, image: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null }, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } } };

export type UpdateBannerMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateBannerInput;
}>;


export type UpdateBannerMutation = { __typename?: 'Mutation', adminBannerUpdate: { __typename?: 'Banner', id: string, image: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null }, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } } };

export type GetBlogsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetBlogsQuery = { __typename?: 'Query', adminBlogs: { __typename?: 'AdminBlogConnection', total: number, items?: Array<{ __typename?: 'AdminBlog', id: string, slug: string, author: string, featureImage: string, createdAt: any, updatedAt: any, publishedAt: any }> | null } };

export type GetBlogQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBlogQuery = { __typename?: 'Query', adminBlog: { __typename?: 'AdminBlog', author: string, featureImage: string, createdAt: any, id: string, slug: string, updatedAt: any, publishedAt: any, blogContents: Array<{ __typename?: 'BlogContent', description?: string | null, language: string, title: string, blogContentSections?: Array<{ __typename?: 'BlogContentSection', content: any, type: string }> | null }> } };

export type CreateBlogMutationVariables = Exact<{
  input: CreateBlogInput;
}>;


export type CreateBlogMutation = { __typename?: 'Mutation', adminBlogCreate: { __typename?: 'AdminBlog', id: string } };

export type UpdateBlogMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateBlogInput;
}>;


export type UpdateBlogMutation = { __typename?: 'Mutation', adminBlogUpdate: { __typename?: 'AdminBlog', id: string } };

export type GetCategoriesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  parentOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCategoriesQuery = { __typename?: 'Query', adminCategories: { __typename?: 'CategoryConnection', total: number, items?: Array<{ __typename?: 'Category', id: string, code: string, icon?: string | null, sortIndex?: number | null, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null }, children?: Array<{ __typename?: 'Category', id: string, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } }> | null, parent?: { __typename?: 'Category', id: string, name: { __typename?: 'TranslationColumn', en: string } } | null }> | null } };

export type GetCategoryQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCategoryQuery = { __typename?: 'Query', category: { __typename?: 'Category', id: string, icon?: string | null, sortIndex?: number | null, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null }, children?: Array<{ __typename?: 'Category', id: string, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } }> | null, parent?: { __typename?: 'Category', id: string, name: { __typename?: 'TranslationColumn', en: string } } | null } };

export type UpdateCategoryMutationVariables = Exact<{
  updateCategoryInput: UpdateCategoryInput;
  id: Scalars['String'];
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', adminCategoryUpdate: { __typename?: 'Category', id: string, icon?: string | null, sortIndex?: number | null, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null }, children?: Array<{ __typename?: 'Category', id: string, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } }> | null, parent?: { __typename?: 'Category', id: string } | null } };

export type CreateCategoryMutationVariables = Exact<{
  input: CreateCategoryInput;
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', adminCategoryCreate: { __typename?: 'Category', id: string, icon?: string | null, sortIndex?: number | null, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null }, children?: Array<{ __typename?: 'Category', id: string, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } }> | null, parent?: { __typename?: 'Category', id: string } | null } };

export type GetConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfigsQuery = { __typename?: 'Query', adminConfigs: { __typename?: 'ConfigConnection', total: number, items?: Array<{ __typename?: 'Config', id: string, name: string, key: string, createdAt: any, updatedAt: any, value: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } }> | null } };

export type GetConfigQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetConfigQuery = { __typename?: 'Query', adminConfig: { __typename?: 'Config', key: string, id: string, name: string, description?: string | null, value: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } } };

export type CreateConfigMutationVariables = Exact<{
  input: CreateConfigInput;
}>;


export type CreateConfigMutation = { __typename?: 'Mutation', adminConfigCreate: { __typename?: 'Config', id: string } };

export type UpdateConfigMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateConfigInput;
}>;


export type UpdateConfigMutation = { __typename?: 'Mutation', adminConfigUpdate: { __typename?: 'Config', id: string } };

export type GetDeliveryOptionsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetDeliveryOptionsQuery = { __typename?: 'Query', adminDeliveryOptions: { __typename?: 'DeliveryOptionConnection', total: number, items?: Array<{ __typename?: 'DeliveryOption', code: string, createdAt: any, icon?: string | null, id: string, showAdditionalInfo: boolean, sortIndex?: number | null, updatedAt: any, additionalInfoLabel?: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } | null, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null }, serviceProviders?: Array<{ __typename?: 'DeliveryServiceProvider', id: string, showAdditionalInfo: boolean, name: { __typename?: 'TranslationColumn', en: string } }> | null }> | null } };

export type GetDeliveryOptionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetDeliveryOptionQuery = { __typename?: 'Query', adminDeliveryOption: { __typename?: 'DeliveryOption', code: string, createdAt: any, icon?: string | null, id: string, showAdditionalInfo: boolean, sortIndex?: number | null, updatedAt: any, additionalInfoLabel?: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } | null, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null }, serviceProviders?: Array<{ __typename?: 'DeliveryServiceProvider', id: string }> | null } };

export type GetDeliveryServiceProvidersQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetDeliveryServiceProvidersQuery = { __typename?: 'Query', adminDeliveryServiceProviders: { __typename?: 'DeliveryServiceProviderConnection', total: number, items?: Array<{ __typename?: 'DeliveryServiceProvider', code: string, createdAt: any, id: string, showAdditionalInfo: boolean, sortIndex?: number | null, updatedAt: any, additionalInfoLabel?: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } | null, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null }, deliveryOption: { __typename?: 'DeliveryOption', id: string } }> | null } };

export type GetDeliveryServiceProviderQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetDeliveryServiceProviderQuery = { __typename?: 'Query', adminDeliveryServiceProvider: { __typename?: 'DeliveryServiceProvider', code: string, createdAt: any, id: string, showAdditionalInfo: boolean, sortIndex?: number | null, updatedAt: any, additionalInfoLabel?: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } | null, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null }, deliveryOption: { __typename?: 'DeliveryOption', id: string } } };

export type GetSearchSuggestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSearchSuggestionsQuery = { __typename?: 'Query', adminSearchSuggestions: { __typename?: 'SearchSuggestionConnection', total: number, items?: Array<{ __typename?: 'SearchSuggestion', id: string, code: string, country: string, longitude: number, latitude: number, sortIndex?: number | null, enabled?: boolean | null, createdAt: any, updatedAt: any, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } }> | null } };

export type GetSearchSuggestionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSearchSuggestionQuery = { __typename?: 'Query', adminSearchSuggestion: { __typename?: 'SearchSuggestion', id: string, code: string, country: string, longitude: number, latitude: number, sortIndex?: number | null, enabled?: boolean | null, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } } };

export type CreateSearchSuggestionMutationVariables = Exact<{
  input: CreateSearchSuggestionInput;
}>;


export type CreateSearchSuggestionMutation = { __typename?: 'Mutation', adminSearchSuggestionCreate: { __typename?: 'SearchSuggestion', id: string } };

export type UpdateSearchSuggestionMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateSearchSuggestionInput;
}>;


export type UpdateSearchSuggestionMutation = { __typename?: 'Mutation', adminSearchSuggestionUpdate: { __typename?: 'SearchSuggestion', id: string } };

export type RemoveSearchSuggestionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveSearchSuggestionMutation = { __typename?: 'Mutation', adminSearchSuggestionRemove: { __typename?: 'SearchSuggestion', id: string } };

export type GetShopsQueryVariables = Exact<{
  filter?: InputMaybe<ShopFilterArgs>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetShopsQuery = { __typename?: 'Query', adminShops: { __typename?: 'ShopConnection', total: number, items?: Array<{ __typename?: 'Shop', createdAt: any, id: string, website?: string | null, slug: string, isOnline: boolean, updatedAt: any, country: AcceptedCountries, categories?: Array<{ __typename?: 'Category', id: string, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } }> | null, description?: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } | null, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null }, user?: { __typename?: 'User', id: string, countryCode: string, phone: string } | null, images?: Array<{ __typename?: 'ShopImage', id: string, url?: string | null, type: ShopImageType }> | null }> | null } };

export type GetShopQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetShopQuery = { __typename?: 'Query', adminShop: { __typename?: 'Shop', createdAt: any, website?: string | null, country: AcceptedCountries, id: string, slug: string, isOnline: boolean, updatedAt: any, authentications?: Array<{ __typename?: 'AuthenticationType', id: string, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } }> | null, categories?: Array<{ __typename?: 'Category', id: string, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } }> | null, deliveryOptions?: Array<{ __typename?: 'ShopDeliveryOption', createdAt: any, customInfo?: string | null, id: string, updatedAt: any, deliveryOption?: { __typename?: 'DeliveryOption', id: string } | null, deliveryServiceProvider?: { __typename?: 'DeliveryServiceProvider', id: string } | null }> | null, description?: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } | null, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null }, socialMedias?: Array<{ __typename?: 'ShopSocialMedia', createdAt: any, id: string, link: string, updatedAt: any, socialMedia: { __typename?: 'SocialMedia', id: string } }> | null, images?: Array<{ __typename?: 'ShopImage', id: string, url?: string | null, type: ShopImageType }> | null, stores?: Array<{ __typename?: 'Store', closingTime?: string | null, createdAt: any, id: string, latitude: number, longitude: number, openingTime?: string | null, updatedAt: any, address?: { __typename?: 'Address', addressLine?: string | null, city?: string | null, country?: string | null, googlePlaceId?: string | null, state?: string | null, zipCode?: string | null } | null, description?: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } | null, name?: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } | null, workingDays?: { __typename?: 'WorkingDays', monday?: boolean | null, tuesday?: boolean | null, wednesday?: boolean | null, thursday?: boolean | null, friday?: boolean | null, saturday?: boolean | null, sunday?: boolean | null } | null }> | null, user?: { __typename?: 'User', countryCode: string, id: string, phone: string } | null } };

export type CreateShopMutationVariables = Exact<{
  input: AdminCreateShopInput;
}>;


export type CreateShopMutation = { __typename?: 'Mutation', adminShopCreate: { __typename?: 'Shop', id: string } };

export type UpdateShopMutationVariables = Exact<{
  id: Scalars['String'];
  input: AdminUpdateShopInput;
}>;


export type UpdateShopMutation = { __typename?: 'Mutation', adminShopUpdate: { __typename?: 'Shop', id: string } };

export type UploadImagesMutationVariables = Exact<{
  shopId: Scalars['String'];
  images: Array<CreateShopImageInput> | CreateShopImageInput;
}>;


export type UploadImagesMutation = { __typename?: 'Mutation', adminUploadShopImages: Array<{ __typename?: 'ShopImage', id: string }> };

export type DeleteImagesMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  shopId: Scalars['String'];
}>;


export type DeleteImagesMutation = { __typename?: 'Mutation', adminDeleteShopImages: Array<{ __typename?: 'ShopImage', id: string }> };

export type GetSocialMediasQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetSocialMediasQuery = { __typename?: 'Query', adminSocialMedias: { __typename?: 'SocialMediaConnection', total: number, items?: Array<{ __typename?: 'SocialMedia', code: string, createdAt: any, icon?: string | null, id: string, updatedAt: any, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null }, label?: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } | null }> | null } };

export type GetSocialMediaQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSocialMediaQuery = { __typename?: 'Query', adminSocialMedia: { __typename?: 'SocialMedia', code: string, createdAt: any, icon?: string | null, id: string, updatedAt: any, name: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null }, label?: { __typename?: 'TranslationColumn', en: string, zhHant?: string | null } | null } };

export type GetUsersQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetUsersQuery = { __typename?: 'Query', adminUsers: { __typename?: 'UserConnection', total: number, items?: Array<{ __typename?: 'User', id: string, countryCode: string, phone: string, role: UserRole, status: UserStatus, createdAt: any, updatedAt: any }> | null } };

export type GetUserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserQuery = { __typename?: 'Query', adminUser: { __typename?: 'User', id: string, countryCode: string, phone: string, role: UserRole, status: UserStatus } };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', adminUserCreate: { __typename?: 'User', countryCode: string, phone: string, status: UserStatus, createdAt: any, updatedAt: any } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', adminUserUpdate: { __typename?: 'User', countryCode: string, phone: string, status: UserStatus, createdAt: any, updatedAt: any } };


export const AdminLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"adminLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"admin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActivated"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}}]}}]}}]} as unknown as DocumentNode<AdminLoginMutation, AdminLoginMutationVariables>;
export const AdminRefreshTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"adminRefreshToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JWT"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminRefreshToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}}]}}]}}]} as unknown as DocumentNode<AdminRefreshTokenMutation, AdminRefreshTokenMutationVariables>;
export const AdminMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"adminMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActivated"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<AdminMeQuery, AdminMeQueryVariables>;
export const GetAuthenticationTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAuthenticationTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAuthenticationTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<GetAuthenticationTypesQuery, GetAuthenticationTypesQueryVariables>;
export const GetAuthenticationTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAuthenticationType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminAuthenticationType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetAuthenticationTypeQuery, GetAuthenticationTypeQueryVariables>;
export const GetBannersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBanners"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminBanners"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"isExpired"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buttonLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"sortIndex"}},{"kind":"Field","name":{"kind":"Name","value":"showButton"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<GetBannersQuery, GetBannersQueryVariables>;
export const GetBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminBanner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buttonLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"showButton"}},{"kind":"Field","name":{"kind":"Name","value":"sortIndex"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetBannerQuery, GetBannerQueryVariables>;
export const CreateBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBannerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminBannerCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createBannerInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}}]}}]}}]} as unknown as DocumentNode<CreateBannerMutation, CreateBannerMutationVariables>;
export const UpdateBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBannerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminBannerUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"updateBannerInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateBannerMutation, UpdateBannerMutationVariables>;
export const GetBlogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBlogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminBlogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<GetBlogsQuery, GetBlogsQueryVariables>;
export const GetBlogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBlog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminBlog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"}},{"kind":"Field","name":{"kind":"Name","value":"blogContents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blogContentSections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}}]}}]}}]} as unknown as DocumentNode<GetBlogQuery, GetBlogQueryVariables>;
export const CreateBlogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createBlog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBlogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminBlogCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createBlogInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateBlogMutation, CreateBlogMutationVariables>;
export const UpdateBlogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateBlog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBlogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminBlogUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"updateBlogInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateBlogMutation, UpdateBlogMutationVariables>;
export const GetCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentOnly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentOnly"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sortIndex"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idOrCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sortIndex"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCategoryQuery, GetCategoryQueryVariables>;
export const UpdateCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateCategoryInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCategoryInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminCategoryUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"updateCategoryInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateCategoryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sortIndex"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const CreateCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCategoryInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminCategoryCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"createCategoryInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sortIndex"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const GetConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<GetConfigsQuery, GetConfigsQueryVariables>;
export const GetConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}}]}}]}}]} as unknown as DocumentNode<GetConfigQuery, GetConfigQueryVariables>;
export const CreateConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateConfigInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminConfigCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateConfigMutation, CreateConfigMutationVariables>;
export const UpdateConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateConfigInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminConfigUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateConfigMutation, UpdateConfigMutationVariables>;
export const GetDeliveryOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDeliveryOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminDeliveryOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"additionalInfoLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}}]}},{"kind":"Field","name":{"kind":"Name","value":"showAdditionalInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"showAdditionalInfo"}},{"kind":"Field","name":{"kind":"Name","value":"sortIndex"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<GetDeliveryOptionsQuery, GetDeliveryOptionsQueryVariables>;
export const GetDeliveryOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDeliveryOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminDeliveryOption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"additionalInfoLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"showAdditionalInfo"}},{"kind":"Field","name":{"kind":"Name","value":"sortIndex"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetDeliveryOptionQuery, GetDeliveryOptionQueryVariables>;
export const GetDeliveryServiceProvidersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDeliveryServiceProviders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminDeliveryServiceProviders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"additionalInfoLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"showAdditionalInfo"}},{"kind":"Field","name":{"kind":"Name","value":"sortIndex"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<GetDeliveryServiceProvidersQuery, GetDeliveryServiceProvidersQueryVariables>;
export const GetDeliveryServiceProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDeliveryServiceProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminDeliveryServiceProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"additionalInfoLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"showAdditionalInfo"}},{"kind":"Field","name":{"kind":"Name","value":"sortIndex"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetDeliveryServiceProviderQuery, GetDeliveryServiceProviderQueryVariables>;
export const GetSearchSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSearchSuggestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminSearchSuggestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"sortIndex"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<GetSearchSuggestionsQuery, GetSearchSuggestionsQueryVariables>;
export const GetSearchSuggestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSearchSuggestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminSearchSuggestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"sortIndex"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]} as unknown as DocumentNode<GetSearchSuggestionQuery, GetSearchSuggestionQueryVariables>;
export const CreateSearchSuggestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createSearchSuggestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSearchSuggestionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminSearchSuggestionCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateSearchSuggestionMutation, CreateSearchSuggestionMutationVariables>;
export const UpdateSearchSuggestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSearchSuggestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSearchSuggestionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminSearchSuggestionUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateSearchSuggestionMutation, UpdateSearchSuggestionMutationVariables>;
export const RemoveSearchSuggestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeSearchSuggestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminSearchSuggestionRemove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveSearchSuggestionMutation, RemoveSearchSuggestionMutationVariables>;
export const GetShopsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getShops"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ShopFilterArgs"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminShops"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<GetShopsQuery, GetShopsQueryVariables>;
export const GetShopDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getShop"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminShop"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authentications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customInfo"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryServiceProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isOnline"}},{"kind":"Field","name":{"kind":"Name","value":"socialMedias"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"socialMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stores"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"googlePlaceId"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"closingTime"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"openingTime"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"workingDays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"monday"}},{"kind":"Field","name":{"kind":"Name","value":"tuesday"}},{"kind":"Field","name":{"kind":"Name","value":"wednesday"}},{"kind":"Field","name":{"kind":"Name","value":"thursday"}},{"kind":"Field","name":{"kind":"Name","value":"friday"}},{"kind":"Field","name":{"kind":"Name","value":"saturday"}},{"kind":"Field","name":{"kind":"Name","value":"sunday"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]}}]} as unknown as DocumentNode<GetShopQuery, GetShopQueryVariables>;
export const CreateShopDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createShop"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminCreateShopInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminShopCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateShopMutation, CreateShopMutationVariables>;
export const UpdateShopDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateShop"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AdminUpdateShopInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminShopUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shopId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateShopMutation, UpdateShopMutationVariables>;
export const UploadImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"images"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateShopImageInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUploadShopImages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopId"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"images"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UploadImagesMutation, UploadImagesMutationVariables>;
export const DeleteImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminDeleteShopImages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteImagesMutation, DeleteImagesMutationVariables>;
export const GetSocialMediasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSocialMedias"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminSocialMedias"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<GetSocialMediasQuery, GetSocialMediasQueryVariables>;
export const GetSocialMediaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSocialMedia"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminSocialMedia"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"en"}},{"kind":"Field","name":{"kind":"Name","value":"zhHant"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetSocialMediaQuery, GetSocialMediaQueryVariables>;
export const GetUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<GetUsersQuery, GetUsersQueryVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUserCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUserUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;